import { render } from "./tw-menu-sidebar.vue?vue&type=template&id=19fe16bd"
import script from "./tw-menu-sidebar.vue?vue&type=script&lang=js"
export * from "./tw-menu-sidebar.vue?vue&type=script&lang=js"
script.render = render

export default script